import { useMutation, useQuery } from "@tanstack/react-query"
import { DefaultOptionType } from "antd/es/select";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { createFeedMemoAdmin, getAllFeedAdmin, getFeedAdminByFeedId } from "../../../../service/feed";
import { getAllFeedCommentAdminByFeedId } from "../../../../service/feedComment";

const useGetFeedAdminByFeedId = <T,>(feedId: number, responseQuery?: string) => {
    const query = useQuery({
        queryKey: ['getFeedAdminByFeedId', feedId, responseQuery],
        queryFn: () => getFeedAdminByFeedId<T>(feedId, responseQuery),
        select: res => res.data.data.getFeedAdminByFeedId,
        enabled: !!feedId
    })
    return query;
}

const useGetAllFeedAdmin = <T,>(responseQuery?: string) => {
    const query = useQuery({
        queryKey: ['getAllFeedAdmin', responseQuery],
        queryFn: () => getAllFeedAdmin<T>(responseQuery),
        select: res => res.data.data.getAllFeedAdmin
    })
    return query;
}

const useCreateFeedMemoAdmin = () => {
    const mutation = useMutation({ mutationFn: createFeedMemoAdmin })
    return mutation
}

const useGetAllFeedCommentAdminByFeedId = <T,>(feedId: number, responseQuery?: string, enabled: boolean = true) => {
    const query = useQuery({
        queryKey: ['getAllFeedCommentAdminByFeedId', feedId, responseQuery],
        queryFn: () => getAllFeedCommentAdminByFeedId<T>(feedId, responseQuery),
        select: res => res.data.data.getAllFeedCommentAdminByFeedId,
        enabled: !!feedId && !!enabled
    })
    return query;
}

const feedColumns: ColumnsType<IFeedAdminResponse> = [
    {
        title: 'No',
        dataIndex: 'id',
        sorter: (a, b) => a.id - b.id
    },
    {
        title: '닉네임',
        dataIndex: 'nickName',
        sorter: (a, b) => a.nickName.localeCompare(b.nickName)
    },
    {
        title: '내용',
        dataIndex: 'content',
        render: (q: string, record) => <Link to={`/community/feed-manage/${record.id}`}>{q.length > 20 ? q.slice(0, 20) + '...' : q}</Link>
    },
    {
        title: '작성일시',
        dataIndex: 'createdDate',
        render: q => dayjs(q).format('YYYY.MM.DD HH:mm'),
        sorter: (a, b) => dayjs(b.createdDate).diff(dayjs(a.createdDate))
    },
    {
        title: '처리상태',
        dataIndex: 'isHidden',
        render: q => (q === undefined || q === null) ? '미처리' : q ? '숨김' : '노출'
    },
    {
        title: '신고횟수',
        dataIndex: 'totalClaimCnt',
        render: q => q ? q : 0,
        sorter: (a, b) => (b.totalClaimCnt ?? 0) - (a.totalClaimCnt ?? 0)
    },
    {
        title: '댓글 수',
        dataIndex: 'feedCommentCnt',
        render: q => q,
        sorter: (a, b) => b.feedCommentCnt - a.feedCommentCnt
    },
    {
        title: '숨김 관리',
        render: (_, record) => <Link to={`/community/feed-manage/${record.id}`}>관리</Link>
    }

]

const feedMemoColumns: ColumnsType<IFeedMemoAdminResponse> = [
    {
        title: 'No',
        dataIndex: 'id'
    },
    {
        title: '내용',
        dataIndex: 'content',
    },
    {
        title: '작성자',
        dataIndex: 'memberName'
    },
    {
        title: '작성일시',
        dataIndex: 'createdDate',
        render: q => dayjs(q).format('YYYY.MM.DD HH:mm')
    },
]

const filterFeedIsHiddenOptions: DefaultOptionType[] = [
    {
        value: 'all',
        label: '전체',
    },
    {
        value: 'false',
        label: '노출',
    },
    {
        value: 'true',
        label: '숨김',
    },
    {
        value: 'null',
        label: '미처리',
    }
]

const filterFeedSearchCategoryOptions: DefaultOptionType[] = [
    {
        value: 'nickName',
        label: '닉네임',
    },
    {
        value: 'content',
        label: '내용',
    },
    {
        value: 'id',
        label: '게시글 ID',
    }
]

const feedClaimDataList = [
    { id: 1, label: '스팸/홍보 도배글입니다.', value: '스팸/홍보 도배글입니다.' },
    { id: 2, label: '음란물입니다.', value: '음란물입니다.' },
    { id: 3, label: '불법 정보를 포함하고 있습니다.', value: '불법 정보를 포함하고 있습니다.' },
    { id: 4, label: '청소년에게 유해한 내용입니다.', value: '청소년에게 유해한 내용입니다.' },
    { id: 5, label: '욕설/생명경시/혐오/차별적 표현입니다.', value: '욕설/생명경시/혐오/차별적 표현입니다.' },
    { id: 6, label: '개인정보 노출 게시물입니다.', value: '개인정보 노출 게시물입니다.' },
    { id: 7, label: '불쾌한 표현이 있습니다.', value: '불쾌한 표현이 있습니다.' }
]

export { useGetFeedAdminByFeedId, useGetAllFeedAdmin, useCreateFeedMemoAdmin, useGetAllFeedCommentAdminByFeedId, feedColumns, feedMemoColumns, filterFeedIsHiddenOptions, filterFeedSearchCategoryOptions, feedClaimDataList }